import {
  withTranslation,
} from 'react-i18next';

import RegattasListView from './RegattasListView';

const TranslatedComponent = withTranslation()(RegattasListView);

const Component = TranslatedComponent;

export default Component;
